<script setup lang="ts">
import { Document, BLOCKS, INLINES } from '@contentful/rich-text-types'
import RichTextRenderer from 'contentful-rich-text-vue-renderer'
import { h } from 'vue'

type RichTextProps = {
  document?: Document
}

const props = defineProps<RichTextProps>()

const customEmbeddedEntry = (node: any, key: any, next: any) => {
  const { fields, componentName } = extractData(node)
  return h(resolveComponent('InlineEntry'), { fields, componentName }, () => next(node.content, key, next))
}

const customEmbeddedBlockEntry = (node: any, key: any, next: any) => {
  const { fields, componentName, sys, url } = extractData(node)
  return h(resolveComponent('BlockEntry'), { fields, componentName, sys }, () => next(node.content, key, next))
}

// NOTE: In legacy but haven't found a usecase for next-gen yet
// const customHyperlink = (node: any, key: any, next: any): VNode => {
//   const { componentName, url } = extractData(node)
//   return h(resolveComponent('Anchor'), { url }, () => next(node.content, key, next))
// }

const extractData = (node: any) => {
  const target = node?.data?.target
  const componentName = target?.sys?.contentType?.sys?.id
  const fields = target?.fields
  const sys = target?.sys
  const url = node?.data?.uri
  return { componentName, fields, sys, url }
}

function renderNodes() {
  /*
    DOC: https://vuejs.org/v2/guide/render-function.html#createElement-Arguments &
    https://github.com/paramander/contentful-rich-text-vue-renderer
  */
  return {
    [INLINES.EMBEDDED_ENTRY]: customEmbeddedEntry,
    [BLOCKS.EMBEDDED_ENTRY]: customEmbeddedBlockEntry,
    // [INLINES.HYPERLINK]: customHyperlink,
  }
}
</script>

<template>
  <div class="rich-text">
    <RichTextRenderer v-if="document" :document="document" :nodeRenderers="renderNodes()" />
  </div>
</template>

<style lang="postcss">
.rich-text {
  ol,
  ul {
    padding-left: var(--space-60);
  }

  ul li {
    list-style-type: unset;
  }

  ol li {
    list-style-type: decimal;
  }

  ol ol li {
    list-style-type: upper-alpha;
  }

  ol ol ol li {
    list-style-type: lower-roman;
  }

  ol ol ol ol li,
  ol ol ol ol ol li {
    list-style-type: lower-alpha;
  }

  p {
    margin-bottom: var(--space-50);
  }

  blockquote {
    border-left: 0.4rem solid var(--ui-neutral-20);
    margin-left: 0.25rem;
    padding-left: 1rem;
  }

  .icon__img {
    width: auto; /* needed for the left align */
  }
}
</style>
